<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import { getUserInfo, logout } from './utils/auth'
export default {
  name: 'App',
  mounted () {
    getUserInfo().then(user => {
      this.$store.dispatch('setUser', { email: user.email })
    }).catch(error => {
      if (error === 'userinfo') logout();
    });
  }
}
</script>
<style lang="scss">
@import "./scss/style.scss";
</style>